export const types = {
  SET_COUNTRY_LIST: "set country list",
  SET_SEARCHED_COUNTRY: "set search Country",
  SET_REGION: "set region",
};
